import { Link, useLoaderData } from "react-router-dom";
import ServerFooter from "../common/ServerFooter";
import { form } from "./types";
/* ---------------- types ---------------- */
export default function AvailableForms(){
    const { forms, total } =
        useLoaderData() as {
        forms: form[];
        total: number;
    };
    return (
        <div className = {"cssContent" + (total > 0?" pb8rem":"")}>
            <h4 className = "mt-2">Available Forms</h4>
            <div className = "mt-2">
                <Link children = "Setting" to = "Setting" className = "btn btn-outline-primary"/>
            </div>
            <div className = "mt-2">
                {forms.length?
                <ul className = "list-group">
                    {forms.map(form => (
                    <li
                        key = {form.id}
                        className = "list-group-item d-flex justify-content-between align-items-center"
                    >
                        <div>
                            <strong>{form.name}</strong>
                            <div className = "text-muted small">
                                Type: {form.type}
                            </div>
                        </div>
                        <div>
                            <Link
                                children = "Add"
                                to = {`${form.id}/Add`}
                                className = "btn btn-outline-primary me-3"
                            />
                            <Link
                                children = "View"
                                to = {`${form.id}`}
                                className = "btn btn-outline-info"
                            />
                        </div>
                    </li>
                    ))}
                </ul>:
                <div className = "alert alert-info text-center">
                    No available forms.
                </div>}
            </div>
            {total > 0? <ServerFooter length = {total}/> : null}
        </div>
    );
}